/* Routes for the activate area (Area A: servers and onboarding). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  focus: [{ path: 'activate', lazy: page(() => import('./pages/ActivatePage')) }],
}
